import { Button } from '@apovisio/ui';
import { LogOut } from 'lucide-react';
import { Link, Outlet, useNavigate } from 'react-router';
import { useLogout, useMe } from '../features/auth/api';
import { BrandMark } from './BrandMark';

export function AdminLayout() {
  const me = useMe();
  const logout = useLogout();
  const navigate = useNavigate();
  return (
    <div className="app-admin">
      <a className="av-skip-link" href="#contenu">
        Aller au contenu
      </a>
      <header className="app-admin__header">
        <Link
          to="/admin"
          className="app-admin__home"
          aria-label="Apogée Visio — accueil de l’espace"
        >
          <BrandMark />
        </Link>
        <div className="av-row">
          <span className="av-text-secondary av-text-sm">{me.data?.user.displayName}</span>
          <Button
            variant="ghost"
            icon={<LogOut />}
            loading={logout.isPending}
            onClick={() => {
              logout.mutate(undefined, {
                onSettled: () => {
                  void navigate('/admin/connexion', { replace: true });
                },
              });
            }}
          >
            Se déconnecter
          </Button>
        </div>
      </header>
      <main id="contenu" className="app-admin__main">
        <Outlet />
      </main>
    </div>
  );
}
